<template>
  <div>
    <kn-form-subtitle :title="`${actionTitle} tipo de opción`" />
    <v-form
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <kn-text-field
        class="mt-4"
        v-model="option.dato"
        label="Nombre:"
        :rules="[rules.required]"
      />
      <kn-form-action-buttons
        class="mb-14"
        :small="true"
        :disableAccept="invalidFields"
        @accept="save"
        @cancel="clear"
      />
    </v-form>
    <kn-form-subtitle
      title="Listado de tipos de opciones de producto"
      divider-position="bottom"
    />
    <kn-list-with-actions
      :activeItems="activeOptions"
      @updateInline="updateInline"
      @deleteInline="deleteInline"
      @cancelInline="clearInline"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { validationFormMixin } from '@/mixins/validationFormMixin'
import { apiMixin } from '@/mixins/apiMixin'
import { fileUtilsMixin } from '@/mixins/fileUtilsMixin'
export default {
  components: {
    KnFormSubtitle: () => import('@/components/KnFormSubtitle.vue'), 
    KnFormActionButtons: () => import('@/components/KnFormActionButtons.vue'),
    KnTextField: () => import('../inputs/KnTextField.vue'),
    KnListWithActions: () => import('./KnListWithActions.vue'),
  },
  mixins: [
    validationFormMixin,
    fileUtilsMixin,
    apiMixin
  ],
  data() {
    return {
      errors: [],
      valid: true,
      option: {
        id: 'NA', // No asignado
        dato: null,
        id_autor: null,
        id_institucion_educativa: null
      },
      options: [],
      toUpdate: false,
    }
  },
  computed: {
    ...mapState(['institutionId', 'userData']),
    actionTitle() {
      return this.toUpdate ? 'Actualizar' : 'Crear'
    },
    activeOptions() {
      return this.options.filter(option => option.estatus_sistema === true)
    },
    invalidFields() {
      return this.objectHasNulls(this.option)
    }
  },
  async created() {
    this.option.id_autor = this.userData.id
    this.option.id_institucion_educativa = this.institutionId
    this.options = await this.fetchResultsByEI('productos', 'tipo-opcion-producto', this.institutionId)
  },
  methods: {
    async createOption() {
      try {
        const response = await this.postObj('/productos/crear-tipo-opcion-producto', {
          tipo_opcion_producto: this.option.dato,
          id_institucion_educativa: this.option.id_institucion_educativa,
          id_autor: this.option.id_autor
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar crear el tipo de opcion de producto', error)
        this.errors.push('Error al intentar crear el tipo de opcion de producto')
      }
    },
    async updateOption() {
      try {
        const response = await this.postObj('/productos/update-tipo-opcion-producto', {
          id: this.option.id,
          tipo_opcion_producto: this.option.dato
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar actualizar el tipo de opcion de producto', error);
      }
    },
    // Los deletes no eliminan los registros, cambian el estatus a False
    async deleteOption(optionId) {
      try {
        const response = await this.postObj('/productos/delete-tipo-opcion-producto', {
          id_tipo_opcion_producto: optionId
        })
        if (response.error) {
          this.errors.push(response.error)
        }
      } catch (error) {
        console.error('Error al intentar eliminar el tipo de opcion de producto', error);
      }
    },
    async save() {
      if (this.toUpdate) {
        await this.updateOption()
        this.toUpdate = false
      } else {
        await this.createOption()
        this.clear()
      }
      this.options = await this.fetchResultsByEI('productos', 'tipo-opcion-producto', this.institutionId)
      this.clear()
    },
    clear() {
      this.option = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    clearInline() {
      this.option = {
        id: 'NA', // No asignado
        dato: null,
        id_autor: this.userData.id,
        id_institucion_educativa: this.institutionId 
      }
      this.toUpdate = false
      this.$refs.form.resetValidation()
    },
    async updateInline(item) {
      // console.log('updateInline item', item);
      this.option = {...item}
      await this.updateOption()
      this.options = await this.fetchResultsByEI('productos', 'tipo-opcion-producto', this.institutionId)
      this.clearInline()
    },
    async deleteInline(itemId) {
      await this.deleteOption(itemId)
      this.options = await this.fetchResultsByEI('productos', 'tipo-opcion-producto', this.institutionId)
      this.clearInline()
    }
  },
}
</script>
